import {
  buildNcrmActivityCreatePayload,
  normalizeNcrmActivityPriority,
  normalizeNcrmActivityStatus,
  resolveNcrmActivityDefaultStatus,
} from "./ncrmActivity.mjs";

export const buildDefaultNcrmActivityTimelineForm = () => ({
  activity_type: "note",
  status: "logged",
  priority: "normal",
  owner_user_id: null,
  title: "",
  content: "",
  due_at: "",
});

export const hydrateNcrmActivityTimelineForm = ({ activity = {}, isNoteType, formatDateTimeLocal }) => {
  const type = activity.activity_type || "note";
  const isNote = isNoteType(type);
  return {
    activity_type: type,
    status: isNote
      ? resolveNcrmActivityDefaultStatus("note")
      : normalizeNcrmActivityStatus(activity.status, type, true) || resolveNcrmActivityDefaultStatus(type),
    priority: isNote
      ? "normal"
      : normalizeNcrmActivityPriority(activity.priority, "normal") || "normal",
    owner_user_id: activity.owner_user_id,
    title: String(activity.title || ""),
    content: String(activity.content || ""),
    due_at: formatDateTimeLocal(activity.due_at),
  };
};

export const buildNcrmActivityTimelineFormPayload = ({
  entityType,
  entityId,
  originEntityType,
  originEntityId,
  form,
  isNoteType,
  requiresDueForType,
}) => {
  const basePayload = buildNcrmActivityCreatePayload({
    entityType,
    entityId,
    originEntityType,
    originEntityId,
    activityType: form.activity_type,
    status: form.status,
    priority: form.priority,
    ownerUserId: form.owner_user_id,
    title: form.title,
    content: form.content,
    dueAt: form.due_at,
  });

  const payload = {
    activity_type: basePayload.activity_type,
    title: basePayload.title,
    content: basePayload.content,
  };

  if (!isNoteType(basePayload.activity_type)) {
    payload.status = basePayload.status;
    payload.priority = basePayload.priority;
  }
  if (basePayload.owner_user_id) {
    payload.owner_user_id = basePayload.owner_user_id;
  }
  payload.due_at = requiresDueForType(basePayload.activity_type) ? basePayload.due_at || null : null;

  return { basePayload, payload };
};
